import { AccountFacade, IStatements } from '@amwager/account/data-access';
import { NumberWithCommasPipe, StatementPipe } from '@amwager/util';
import { IEventsNameAndIdModel, POOL_LIST_ID } from '@amwager/util-ts';
import { WagerFacade } from '@amwager/wager/data-access';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertController, IonContent, IonDatetime, IonDatetimeButton, IonIcon, IonInput, IonItem, IonList, IonModal, IonSelect, IonSelectOption } from '@ionic/angular/standalone';
import moment from 'moment';

@Component({
  selector: 'feature-ion-statements',
  templateUrl: './statements.component.html',
  styleUrls: ['./statements.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonDatetimeButton,
    IonDatetime,
    IonModal,
    IonInput,
    IonContent,
    IonSelect,
    IonSelectOption,
    ReactiveFormsModule,
    CommonModule,
    NumberWithCommasPipe,
    IonList,
    IonItem,
    StatementPipe,
    IonIcon
  ]
})
export class StatementsComponent implements OnInit {

  POOL_LIST_ID: string[] = POOL_LIST_ID;

  tracks!: IEventsNameAndIdModel[];
  getStatementsForm!: FormGroup;

  statements?: IStatements;

  isDateEnabledFrom = (dateString: string) => {
    const dateFrom = moment(new Date(dateString)).subtract(1, 'days');
    const dateTo = moment(new Date(this.formVal['dateTo']?.value));

    return dateFrom.isSameOrBefore(dateTo);
  };

  isDateEnabledTo = (dateString: string) => {
    const dateFrom = moment(new Date(this.formVal['dateFrom']?.value));
    const dateTo = moment(new Date(dateString));

    return dateFrom.isSameOrBefore(dateTo);
  };

  get formVal() { return this.getStatementsForm?.controls }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly wagerFacade: WagerFacade,
    private readonly accountFacade: AccountFacade,
    private readonly cdRef: ChangeDetectorRef,
    private readonly alertCtrl: AlertController,
  ) { }

  ngOnInit() {
    this.initForm();

    this.wagerFacade.getAllEventsNameAndId$()
      .subscribe((data) => {
        // console.log('AllAvailableEvents:', data)
        this.tracks = data?.response?.AllAvailableEvents;

        this.cdRef.markForCheck();
      });

    this.accountFacade.getAccountStatements(
      'StatementsComponent:ngOnInit',
      {
        startDate: this.formVal['dateFrom']?.value,
        endDate: this.formVal['dateTo']?.value
      }
    );
    this.accountFacade.getAccountStatements$()
      .subscribe((statements?: IStatements) => {
        this.statements = undefined;

        if (statements?.response?.error) {
          this.showAlertMessage('Error', statements?.response?.error?.Message);
        }
        else this.statements = statements;

        // console.log('this.statements:', this.statements);

        this.cdRef.markForCheck();
      });
  }

  private initForm(): void {
    // console.log('new Date().toISOString():', moment(new Date()).format("YYYY-MM-DDThh:mm"));

    this.getStatementsForm = this.formBuilder.group({
      dateFrom: [moment(new Date()).subtract(1, 'days').format("YYYY-MM-DDTHH:mm"), [Validators.required]],
      dateTo: [moment(new Date()).format("YYYY-MM-DDTHH:mm"), [Validators.required]],
      track: [''],
      pool: ['']
    });

    // "MM/DD/YYYY h:mm A"

    // this.formVal['dateFrom'].setValue('2024-06-24T20:25:00');
  }

  setDate(event: any, type: 'dateFrom' | 'dateTo') {
    const value = event?.detail?.value;
    // console.log('setDate:', value);

    this.formVal[type]?.setValue(value);
    this.checkDate();
  }

  setInputDate(e: any) {
    // console.log(e);
    null;
  }

  checkDate(): boolean {
    let result = false;

    if (this.formVal['dateFrom']?.value > this.formVal['dateTo']?.value) {
      this.showAlertMessage('Error', 'Date To should not be less than Date From.');
      result = true;
    }

    return result;
  }

  trackByFn(index: number, item: any): number {
    return item.id; // Use the unique ID property for tracking
  }

  searchStatements(): void {

    if (this.checkDate())
      return;

    // console.log('getStatementsForm:', this.getStatementsForm)
    // console.log('getStatementsForm:',  this.formVal['track']?.value)

    this.accountFacade.getAccountStatements(
      'StatementsComponent:searchStatements',
      {
        startDate: this.formVal['dateFrom']?.value,
        endDate: this.formVal['dateTo']?.value,
        poolId: this.formVal['pool']?.value || undefined,
        eventId: this.formVal['track']?.value?.EventId || undefined
      }
    );
  }

  async showAlertMessage(header: string, message: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header,
      message: message,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }
}
